import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Modal, Row, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { formatAmount } from '../../../common/utils/common.utils';

type Props = {
  setIata?: React.Dispatch<React.SetStateAction<string>>;
  iata?: any;
};

const IataBspModal = ({ iata, setIata }: Props) => {
  console.log(iata, 'iata');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const balance = iata.amount_to_be_paid - iata.bsp_paid;
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setIata && setIata('');
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIata && setIata('');
  };

  useEffect(() => {
    if (iata) showModal();
  }, [iata]);

  // Custom styles to match the design
  const tableStyles = `
    .custom-table .ant-table-thead > tr > th {
      background: #f5f7fa;
      color: #000;
      font-weight: 600;
    }
    .custom-table .ant-table-tbody > tr > td {
      padding: 8px;
    }
    .custom-table .ant-table-tbody > tr > td:first-child {
      color: #1890ff;
    }
    .summary-row {
      background: #f5f7fa;
      font-weight: bold;
    }
    .summary-title {
      color: #ff4d4f;
      font-weight: bold;
      margin-bottom: 8px;
      border-bottom: 2px solid #ff4d4f;
      display: inline-block;
    }
    .timestamp {
      color: #888;
      font-size: 12px;
      margin-bottom: 16px;
    }
    .csv-download {
      float: right;
      color: #1890ff;
      cursor: pointer;
      font-size: 14px;
    }
    .balance-section {
      text-align: right;
      margin-top: 16px;
    }
    .balance-amount {
      color: #000;
      font-weight: bold;
      margin-right: 8px;
    }
    .pending-status {
      color: #fa8c16;
      background: #fff7e6;
      padding: 4px 8px;
      border-radius: 4px;
      font-weight: bold;
    }
  `;
  const billing = iata?.amount_to_be_paid ?? 0;
  const payment = iata?.bsp_paid ? -parseFloat(iata.bsp_paid) : 0;
  return (
    <>
      <div style={{ margin: '0 25px' }}>
        <style>{tableStyles}</style>
        <FontAwesomeIcon
          onClick={showModal}
          style={{
            border: '1px solid lightgrey',
            padding: '5px',
            borderRadius: '100%',
            fontSize: '16px',
            cursor: 'pointer',
            display: setIata ? 'none' : 'block',
          }}
          icon={faPaperclip}
        />
        <Modal
          title={<Typography.Title level={3}>{`${iata?.bsp_period} Period`}</Typography.Title>}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={false}
          centered
          width={720}
          style={{ top: 20 }}
        >
          <div className='summary-title'>Summary</div>
          <div
            style={{
              fontFamily: 'Inter, sans-serif',
              maxWidth: 800,
              margin: '0 auto',
              paddingTop: 20,
            }}
          >
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <th style={{ textAlign: 'left', padding: '10px 8px', fontWeight: 'bold' }}>
                    Item
                  </th>
                  <th style={{ textAlign: 'right', padding: '10px 8px', fontWeight: 'bold' }}>
                    Billing BDT
                  </th>
                  <th style={{ textAlign: 'right', padding: '10px 8px', fontWeight: 'bold' }}>
                    Payment BDT
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Expected Remittance */}
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '10px 8px' }}>Expected Remittance</td>
                  <td style={{ textAlign: 'right', padding: '10px 8px' }}>
                    {formatAmount(billing)}
                  </td>
                  <td style={{ textAlign: 'right', padding: '10px 8px' }}>0.00</td>
                </tr>

                {/* Payment Received */}
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '10px 8px' }}>
                    {/* <span style={{ display: 'inline-block', width: 16 }}>▸</span> */}
                    Payment Received
                  </td>
                  <td style={{ textAlign: 'right', padding: '10px 8px' }}>0.00</td>
                  <td style={{ textAlign: 'right', padding: '10px 8px' }}>
                    {formatAmount(payment)}
                  </td>
                </tr>

                {/* Sum Row */}
                <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 'bold' }}>Sum</td>
                  <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>
                    {formatAmount(billing)}
                  </td>
                  <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>
                    {formatAmount(payment)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <Row>
            <Col span={12}></Col>
            <Col span={12}>
              <div style={{ textAlign: 'right', fontFamily: 'Inter, sans-serif' }}>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: '20px',
                    textAlign: 'left',
                    marginTop: '8px',
                    borderBottom: '1px solid #e0e0e0',
                  }}
                >
                  Balance
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '12px',
                    marginTop: '12px',
                  }}
                >
                  <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    BDT{' '}
                    {(
                      parseFloat(iata.amount_to_be_paid || 0) - parseFloat(iata.bsp_paid || 0)
                    ).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                  </span>

                  <span
                    style={{
                      borderRadius: '4px',
                      fontWeight: 500,
                      fontSize: '12px',
                      backgroundColor: balance <= 0 ? '#b8e9b2' : '#f6c636',
                      color: 'black',
                      padding: '4px 10px',
                    }}
                  >
                    {balance <= 0 ? 'PAYMENT COMPLETED' : 'PENDING'}{' '}
                  </span>
                  <FontAwesomeIcon
                    style={{
                      border: '1px solid lightgrey',
                      padding: '5px',
                      borderRadius: '100%',
                      fontSize: '16px',
                      cursor: 'pointer',
                    }}
                    icon={faPaperclip}
                  />
                </div>
              </div>{' '}
            </Col>
          </Row>
        </Modal>
      </div>
    </>
  );
};

export default IataBspModal;
